export const CadastroStatusEnum = {
  Ativo: "Ativo",
  Inativo: "Inativo",
  Bloqueado: "Bloqueado",
  IndisponivelAusente: "IndisponivelAusente",
  Excluido: "Excluido",
  Execucao: "Execucao",
  Elaborado: "Elaborado",
  Programado: "Programado",
  Concluido: "Concluido",
  Rascunho: "Rascunho",
  Cancelado: "Cancelado",
};

export const CadastroStatusLabel = (status) => {
  switch (status) {
    case CadastroStatusEnum.Ativo:
      return "Ativo";
    case CadastroStatusEnum.Inativo:
      return "Inativo";
    case CadastroStatusEnum.Bloqueado:
      return "Bloqueado";
    case CadastroStatusEnum.IndisponivelAusente:
      return "Indisponível/Ausente";
    case CadastroStatusEnum.Excluido:
      return "Excluido";
    case CadastroStatusEnum.Execucao:
      return "Execução";
    case CadastroStatusEnum.Elaborado:
      return "Elaborado";
    case CadastroStatusEnum.Programado:
      return "Programado";
    case CadastroStatusEnum.Concluido:
      return "Concluido";
    case CadastroStatusEnum.Rascunho:
      return "Rascunho";
    case CadastroStatusEnum.Cancelado:
      return "Cancelado";
  }
  return status;
};

export const CadastroStatusLocacaoColors = (cadastroStatus) => {
  switch(cadastroStatus)
  {
    case CadastroStatusEnum.Programado:
    case CadastroStatusEnum.Elaborado:
      return 'bg-info text-white'
    case CadastroStatusEnum.Execucao:
      return 'bg-primary text-white'
    case CadastroStatusEnum.Concluido:
      return 'bg-success text-white'
    case CadastroStatusEnum.Cancelado:
      return 'bg-danger text-white'
  }
  return;
}

export const TipoEnderecoEnum = {
  CanteiroObra: "CanteiroObra",
  ViaPublica: "ViaPublica",
};

export const TipoEnderecoLabel = (tipoEndereco) => {
  switch (tipoEndereco) {
    case TipoEnderecoEnum.CanteiroObra:
      return "Canteiro de Obra";
    case TipoEnderecoEnum.ViaPublica:
      return "Via Pública";
  }
  return tipoEndereco;
};

export const TipoClienteEnum = {
  PessoaJuridica: "PessoaJuridica",
  PessoaFisica: "PessoaFisica",
};

export const TipoClienteLabel = (tipoCliente) => {
  switch (tipoCliente) {
    case TipoClienteEnum.PessoaFisica:
      return "Pessoa Física";
    case TipoClienteEnum.PessoaJuridica:
      return "Pessoa Jurídica";
  }
  return tipoCliente;
};

export const estadosBrasilOptions = [
  { text: "Acre", value: "AC" },
  { text: "Alagoas", value: "AL" },
  { text: "Amapá", value: "AP" },
  { text: "Amazonas", value: "AM" },
  { text: "Bahia", value: "BA" },
  { text: "Ceará", value: "CE" },
  { text: "Distrito Federal", value: "DF" },
  { text: "Espírito Santo", value: "ES" },
  { text: "Goiás", value: "GO" },
  { text: "Maranhão", value: "MA" },
  { text: "Mato Grosso", value: "MT" },
  { text: "Mato Grosso do Sul", value: "MS" },
  { text: "Minas Gerais", value: "MG" },
  { text: "Pará", value: "PA" },
  { text: "Paraíba", value: "PB" },
  { text: "Paraná", value: "PR" },
  { text: "Pernambuco", value: "PE" },
  { text: "Piauí", value: "PI" },
  { text: "Rio de Janeiro", value: "RJ" },
  { text: "Rio Grande do Norte", value: "RN" },
  { text: "Rio Grande do Sul", value: "RS" },
  { text: "Rondônia", value: "RO" },
  { text: "Roraima", value: "RR" },
  { text: "Santa Catarina", value: "SC" },
  { text: "São Paulo", value: "SP" },
  { text: "Sergipe", value: "SE" },
  { text: "Tocantins", value: "TO" },
];

export const TipoLogEnum = {
  I: "Inserção",
  U: "Atualizar",
  D: "Exclusão",
  O: "Outros/Informativo",
};

export const EntidadeLabel = (entidade) => {
  switch (entidade) {
    case "Role":
      return "Papéis/funções";
    case "Usuario":
      return "Usuários";
    case "Veiculo":
      return "Veículos";
    case "TipoVeiculo":
      return "Tipos de Veículo";
    case "Cacamba":
      return "Caçambas";
    case "TipoCacamba":
      return "Tipos de Caçamba";
    case "Cliente":
      return "Clientes";
    case "Contato":
      return "Clientes - Contatos";
    case "LocalEntrega":
      return "Clientes - Locais de Entrega";
    case "Motorista":
      return "Motoristas";
    case "Multa":
      return "Multas";
    case "ParametrosEmpresa":
      return "Parâmetros - Empresa";
    case "LocalDestinacao":
      return "Locais de Destinação";
    case "TipoResiduo":
      return "Tipos de Resíduo";
    case "Turno":
      return "Turnos";
    default:
      break;
  }
  return entidade;
};

export const TipoLogEnumLabel = (tipoLog) => {
  return TipoLogEnum[tipoLog];
};

export const PrioridadeEnum = {
  Baixa: "Baixa",
  Normal: "Normal",
  Alta: "Alta",
};

export const PrioridadeLabel = (prioridade) => {
  switch (prioridade) {
    case PrioridadeEnum.Baixa:
      return "Baixa";
    case PrioridadeEnum.Normal:
      return "Normal";
    case PrioridadeEnum.Alta:
      return "Alta";
  }
  return prioridade;
};

export const PeriodoEnum = {
  TresDias: 3,
  SeteDias: 7,
  QuinzeDias: 15,
  TrintaDias: 30,
  SessentaDias: 60
};

export const PeriodoLabelProximos = (periodo) => {
  switch (periodo) {
    case PeriodoEnum.TresDias:
      return "Próximos 3 dias";
    case PeriodoEnum.SeteDias:
      return "Próximos 7 dias";
    case PeriodoEnum.QuinzeDias:
      return "Próximos 15 dias";
    case PeriodoEnum.TrintaDias:
      return "Próximos 30 dias";
    case PeriodoEnum.SessentaDias:
      return "Próximos 60 dias";
  }
  return periodo;
};

export const PeriodoLabelAnteriores = (periodo) => {
  switch (periodo) {
    case PeriodoEnum.TresDias:
      return "Últimos 3 dias";
    case PeriodoEnum.SeteDias:
      return "Últimos 7 dias";
    case PeriodoEnum.QuinzeDias:
      return "Últimos 15 dias";
    case PeriodoEnum.TrintaDias:
      return "Últimos 30 dias";
    case PeriodoEnum.SessentaDias:
      return "Últimos 60 dias";
  }
  return periodo;
};

export const RoteiroItemStatusEnum =
{
    Pendente: "Pendente",
    Perdido: "Perdido",
    Realizado: "Realizado"
}

export const TipoViagemRotaProgramacaoEnum = {
  Coloca: 'Coloca',
  Retira: 'Retira'
}

export const StatusCtrEnum = {  
  Pendente: 'Pendente',
  Sucesso: 'Sucesso',
  Erro: 'Erro'
}

export const TipoItemFilaIntegracaoEnum = {  
  ConfirmarRetirada: 'ConfirmarRetirada',
  ConfirmarRoteiro: 'ConfirmarRoteiro',
  EstacionaCacamba: 'EstacionaCacamba'
}

export const TipoItemFilaIntegracaoLabel = (tipo) => {
  switch (tipo) {
    case TipoItemFilaIntegracaoEnum.ConfirmarRetirada:
      return "Retirar caçamba";
    case TipoItemFilaIntegracaoEnum.ConfirmarRoteiro:
      return "Obter CTR";
    case TipoItemFilaIntegracaoEnum.EstacionaCacamba:
      return "Estacionar Caçamba";
  }
  return tipo;
}


export const colorsCharts = {
  yellow: '#f7d24b',
  green: '#1dcf7a',
  blue: '#3281f3',
  red: '#f56665'
}

